import { useTranslation } from 'react-i18next';

import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import cx from 'classnames';

import { Image } from '~/components/Image';
import ProgressIndicator from '~/components/ProgressIndicator';
import Text from '~/components/Text';

const Reward = ({
  name,
  description,
  disclaimer,
  image,
  isAchieved,
  // biome-ignore lint/correctness/noUnusedVariables: Keeping for backwards compatibility
  prefixedArticle,
  numerator,
  denominator,
  // biome-ignore lint/correctness/noUnusedVariables: Keeping for backwards compatibility
  showProgress,
}: any) => {
  const { t } = useTranslation();

  return (
    <div className="relative">
      {isAchieved && <CheckCircleIcon className="absolute -right-2 -top-2 z-10 h-6 w-6 text-green-500" />}
      <div className={cx('relative space-y-2 rounded-md border border-gray-200 p-4', isAchieved ? 'opacity-50' : '')}>
        <div className="flex justify-between">
          <div className="flex w-fit flex-col space-x-0 sm:w-full sm:flex-row sm:space-x-4">
            <div className="mb-4 h-24 w-24 rounded shadow-md">
              <Image
                src={image}
                className="h-full rounded object-contain"
                aspectRatio="square"
                maxWidth={200}
                widthClass="w-24"
                alt={''}
              />
            </div>
            <div className="w-full">
              <Text as="h4" size={'lg'} weight="semibold" theme="default" className="pb-1">
                {name}
              </Text>
              <Text as="p" size={'sm'} weight="regular" theme="default" className="font-regular opacity-75">
                {description}
              </Text>
              {disclaimer && (
                <div className="mt-2 rounded-md bg-blue-50 p-2">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <InformationCircleIcon className="h-5 w-5 text-blue-700" aria-hidden="true" />
                    </div>
                    <div className="ml-3 flex-1 md:flex md:justify-between">
                      <p className="text-sm text-blue-700">
                        <span className="font-medium">{`${t('referrals.reward.disclaimer')}:`}</span> {disclaimer}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="flex flex-col items-end">
          <h4 className="tracking-medium mb-1 h-fit text-lg font-bold leading-tight text-gray-900">
            {numerator}/{denominator}
          </h4>

          <ProgressIndicator variant="reward" currentProgress={Math.round((numerator / denominator) * 100)} />
        </div>
      </div>
    </div>
  );
};

export default Reward;
